import React from 'react';
import classes from './PolicyBlocked.module.css';
import { auth, logout } from '../../firebase/firebase';
import CalendlyPopupButton from '../CalendlyPopupButton/CalendlyPopupButton';
import { CALENDLY_URL } from '../../../config/calendly';
import { Urls } from '../../../Urls';

const PolicyBlocked = () => {
  const handleLogout = () => {
    sessionStorage.clear();
    localStorage.clear();
    logout(auth);
    window.location.reload();
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.card}>
        <div className={classes.brandBar}>
          <img src={Urls.LorriLogoLogin} alt="LoRRI" className={classes.logo} />
        </div>

        <div className={classes.body}>
          <span className={classes.badge}>&#10003; Sign-up received</span>

          <h1 className={classes.heading}>You're almost in</h1>
          <p className={classes.subtext}>
            We activate LoRRI accounts after a short walkthrough, so the
            platform is set up for your needs and data from day one.
          </p>

          <div className={classes.steps}>
            <div className={classes.step}>
              <span className={classes.stepIcon}>&#128172;</span>
              <span className={classes.stepLabel}>A quick conversation</span>
            </div>
            <div className={classes.step}>
              <span className={classes.stepIcon}>&#9881;</span>
              <span className={classes.stepLabel}>Setup around your needs</span>
            </div>
            <div className={classes.step}>
              <span className={classes.stepIcon}>&#128640;</span>
              <span className={classes.stepLabel}>Your workspace goes live</span>
            </div>
          </div>

          {/* <CalendlyPopupButton
            url={CALENDLY_URL}
            text="Book a 30-min demo  →"
            className={classes.ctaBtn}
            triggerPopup
            moduleName="Policy Blocked"
          /> */}

          <span className={classes.pill}>Most teams are live within a week</span>

          <hr className={classes.divider} />

          <p className={classes.footerText}>
            Our team will also reach out within one business day.
            <br />
            Need us sooner? Email us at{" "}
            <a className={classes.link} href="mailto:associate@logisticsnow.in">
              associate@logisticsnow.in
            </a>
            <br />
            or call us on{" "}
            <a className={classes.link} href="tel:+919867773508">
              +91-9867773508
            </a>
          </p>

          <button type="button" className={classes.logoutBtn} onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default PolicyBlocked;
